import { JobStatusEnum } from 'graphql-common';
import styles from 'components/JobTracker/JobTracker.module.scss';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import CircleLoader, { Types } from '@lib/components/CircleLoader/CircleLoader';
import React from 'react';

const getJobIcon = (status: JobStatusEnum | null) => {
  switch (status) {
    case JobStatusEnum.Complete:
      return (
        <div className={styles.jobCompleteIcon}>
          <MaterialIcon icon="check_circle" filled size="md-16" />
        </div>
      );
    case JobStatusEnum.Failed:
      return (
        <div className={styles.jobFailedIcon}>
          <MaterialIcon icon="warning" filled size="md-16" />
        </div>
      );
    case JobStatusEnum.Interrupted:
      return (
        <div className={styles.jobInterruptedIcon}>
          <MaterialIcon icon="warning" filled size="md-16" />
        </div>
      );
    case JobStatusEnum.Stopped:
      return (
        <div className={styles.jobStoppedIcon}>
          <MaterialIcon icon="cancel" filled size="md-16" />
        </div>
      );
    default:
      return <CircleLoader padding="" type={Types.GIF} />;
  }
};

export default getJobIcon;
